import { defineMessages } from 'react-intl';

export default defineMessages({
  additionalFieldsRequired: {
    id: 'metamorph.additional-fields-required',
    defaultMessage:
      'In order to complete your claim we need a few more details in order to sign up',
  },
});
